import Amount from "@/models/Shared/Amount";
import SecondaryWalletType from '@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletType';

export default class Wallet {
    id: string;
    name: string;
    currency: string;
    createdAt: string;
    updatedAt: string;
    default: boolean;
    state: string;
    iban: string;
    accountNumber: string;
    availableBalance: Amount = new Amount();
    balance: Amount = new Amount();
    walletSettings: SecondaryWalletType = new SecondaryWalletType();
    accrualAmount: Amount = new Amount();
}